/**
 * Created by marlon.jerez on 13/07/2016.
 */

declare const jQuery:any;
const TABLET_SIZE = 992;
export class topBanner{
	constructor(){
		var w = jQuery(window).width();
		if(jQuery(".homePage.app").length >= 1 || w <= TABLET_SIZE){
			jQuery('.topBanner-title').addClass("active");
		}else{
			jQuery('.topBanner-title').slabText().addClass("active");
		}
	}
}
